function initAwFaqBox(box) {
  var items = box.querySelectorAll('.aw-faq__item');

  items.forEach(function (item) {
    var trigger = item.querySelector('.aw-faq__trigger');
    var panel = item.querySelector('.aw-faq__panel');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      toggleAwFaqItem(items, item);
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      event.preventDefault();
      toggleAwFaqItem(items, item);
    });
  });

  var openPanel = box.querySelector('.aw-faq__item.is-open .aw-faq__panel');
  if (openPanel) openPanel.style.maxHeight = openPanel.scrollHeight + 'px';
}

function toggleAwFaqItem(items, item) {
  var trigger = item.querySelector('.aw-faq__trigger');
  var panel = item.querySelector('.aw-faq__panel');
  var isOpen = item.classList.contains('is-open');

  items.forEach(function (other) {
    if (other === item) return;
    other.classList.remove('is-open');
    other.querySelector('.aw-faq__trigger').setAttribute('aria-expanded', 'false');
    other.querySelector('.aw-faq__panel').style.maxHeight = null;
  });

  if (isOpen) {
    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = null;
  } else {
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }
}

function initAwCarousel(carousel) {
  var track = carousel.querySelector('[data-aw-carousel-track]');
  var slides = carousel.querySelectorAll('[data-aw-carousel-slide]');
  var prevBtn = carousel.querySelector('[data-aw-carousel-prev]');
  var nextBtn = carousel.querySelector('[data-aw-carousel-next]');
  var dotsWrap = carousel.parentNode.querySelector('[data-aw-carousel-dots]');
  var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-aw-carousel-dot]') : [];
  if (!track || !slides.length) return;

  function goToSlide(index) {
    var clamped = Math.max(0, Math.min(index, slides.length - 1));
    slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function currentIndex() {
    var trackRect = track.getBoundingClientRect();
    var center = trackRect.left + trackRect.width / 2;
    var closest = 0;
    var closestDistance = Infinity;
    slides.forEach(function (slide, index) {
      var rect = slide.getBoundingClientRect();
      var distance = Math.abs(rect.left + rect.width / 2 - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });
    return closest;
  }

  function setActiveDot(index) {
    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIndex() - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIndex() + 1); });

  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () { goToSlide(index); });
  });

  var scrollTimeout;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      setActiveDot(currentIndex());
    }, 100);
  });
}

$(document).ready(function () {
  document.querySelectorAll('.aw-faq__box').forEach(initAwFaqBox);
  document.querySelectorAll('[data-aw-carousel]').forEach(initAwCarousel);

  $(document).on('click', '[data-aw-scroll-target]', function (event) {
    event.preventDefault();

    var $target = $('.ts_product-title-flex_line').first();
    if (!$target.length) return;

    var $html = $('html');
    var previousScrollBehavior = $html.css('scroll-behavior');
    $html.css('scroll-behavior', 'auto');

    $('html, body').animate({ scrollTop: $target.offset().top - 100 }, 600, function () {
      $html.css('scroll-behavior', previousScrollBehavior);
    });
  });
});
